import React from "react";
import PropTypes from "prop-types";

import { Button, Typography, GridContainer, Row, Column, Link } from "@vp/swan";

import l10n from "../localization/localization";
import styles from "../styles/cookie-message-style.scss";
import getUrl from "./get-url";

export default function BannerVariationCa(props) {
  const { onAcceptAll, onAcceptNecessary, onChangePreferences } = props;
  return (
    <GridContainer
      className={`${styles.cookiePolicyControl} grid-container-proportional consent-manager-banner`}
      backgroundColor="standard"
      aria-labelledby="cookie-dialog-title"
      role="dialog"
      aria-describedby="cookie-dialog-description"
    >
      <Row marginTop="4" marginBottom="6">
        <Column span={12} spanXs={12}>
          <Typography
            textAlign="left"
            fontSize="x2large"
            width="100%"
            fontWeight="bold"
            id="cookie-dialog-title"
          >
            {l10n.t("bannerV5.title")}
          </Typography>
        </Column>
      </Row>
      <Row marginY="3">
        <Column span={12}>
          <Typography textAlign="left" id="cookie-dialog-description">
            {l10n.t("bannerV5.content").replace("#policy-link#.", "")}
            <Link href={getPolicyLink()}>
              {l10n.t("bannerV5.policyLinkText")}
            </Link>
            {"."}
          </Typography>
        </Column>
      </Row>
      <Row marginTop="6" paddingX="0">
        <Column textAlign="right" span={12} paddingX="0">
          <Button
            skin="secondary"
            className={`${styles.caButton} ${styles.textButton} ${styles.wrappedText} `}
            title={l10n.t("bannerV5.settings")}
            aria-label={l10n.t("bannerV5.settings")}
            onClick={onChangePreferences}
          >
            {l10n.t("bannerV5.settings")}
          </Button>

          <Button
            skin="primary"
            className={`${styles.caButton} ${styles.acceptButton} ${styles.wrappedText}  `}
            title={l10n.t("bannerV5.accept")}
            aria-label={l10n.t("bannerV5.accept")}
            onClick={onAcceptAll}
          >
            {l10n.t("bannerV5.accept")}
          </Button>
        </Column>
      </Row>
    </GridContainer>
  );
}

function getPolicyLink() {
  return getUrl(l10n.tUrl("privacyAndCookiePolicy"));
}

BannerVariationCa.displayName = "Banner";

BannerVariationCa.propTypes = {
  onAcceptAll: PropTypes.func.isRequired,
  onAcceptNecessary: PropTypes.func.isRequired,
  onChangePreferences: PropTypes.func.isRequired,
};
